// frontend/src/components/CircleToast.jsx

import React from "react";
import {
  CheckCircle,
  XCircle,
  CopySimple,
  X,
} from "phosphor-react";

export default function CircleToast({
  toast,
  onClose,
  onCopyAgain,

  // Optional per-instance styling overrides.
  // Existing CircleToast usages do not need to pass any of these.
  wrapperClassName = "",
  toastClassName = "",
  contentClassName = "",
  copyClassName = "",
  closeClassName = "",
}) {
  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      className={[
        "pointer-events-none fixed bottom-6 inset-x-0 z-[60] flex justify-center px-9 sm:px-4",
        wrapperClassName,
      ].join(" ")}
    >
      {toast && (
        <div
          role={toast.kind === "error" ? "alert" : "status"}
          className={[
            "pointer-events-auto relative w-full max-w-md",
            "rounded-full shadow-[0_8px_0px_rgba(37,99,235,0.96)] ring-1",
            toast.kind === "error"
              ? "bg-blue-200/95 ring-red-200"
              : "bg-blue-200/95 ring-blue-200",
            "px-10 pt-3 pb-2",
            "transition-all duration-300 ease-out",
            "animate-[toastIn_0.28s_cubic-bezier(.2,.9,.2,1)]",
            toastClassName,
          ].join(" ")}
        >
          <div
            className={[
              "flex items-center pt-2 sm:pt-0 sm:gap-3 sm:pr-7",
              contentClassName,
            ].join(" ")}
          >
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1">
                {toast.kind === "error" ? (
                  <XCircle
                    className="shrink-0 text-red-500"
                    size={16}
                    weight="fill"
                  />
                ) : (
                  <CheckCircle
                    className="shrink-0 text-blue-700"
                    size={16}
                    weight="fill"
                  />
                )}

                <p className="text-sm leading-none sm:leading-5 text-gray-900">
                  {toast.message}
                </p>
              </div>

              {toast.copyAgain && (
                <button
                  type="button"
                  onClick={onCopyAgain}
                  className={[
                    "sm:mt-1 -mt-2 inline-flex items-center gap-1 text-xs font-medium text-blue-700 hover:underline",
                    copyClassName,
                  ].join(" ")}
                >
                  <CopySimple size={16} />
                  Copy again
                </button>
              )}
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className={[
              "absolute right-2 sm:right-5 top-1 sm:top-3 p-1 text-gray-500 transition",
              closeClassName,
            ].join(" ")}
            aria-label="Dismiss"
            title="Dismiss"
          >
            <X size={16} weight="bold" />
          </button>
        </div>
      )}
    </div>
  );
}